import { ChangeDetectionStrategy, Component, HostListener, OnInit } from '@angular/core';
import { LoadingService } from '@core/services/loading/loading.service';
import { Observable } from 'rxjs';
import { MbProgressBarModule } from '@am/moebius';
import { NgIf, AsyncPipe } from '@angular/common';

@Component({
    selector: 'progress-bar',
    templateUrl: './progress-bar.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        NgIf,
        MbProgressBarModule,
        AsyncPipe,
    ],
})
export class ProgressBarComponent implements OnInit {
  public pageLoading = true;
  public loading$: Observable<boolean>;

  constructor(private readonly loadingService: LoadingService) {}

  @HostListener('document:readystatechange', ['$event.target.readyState'])
  handleDocumentStateChange(state: string) {
    if (state === 'complete') {
      // this.pageLoading = false;
      // this.checkLoaderVisibility();
    }
  }

  ngOnInit(): void {
    this.loading$ = this.loadingService.loading$;
  }
}
